import { render, staticRenderFns } from "./SvgIconBrowser.vue?vue&type=template&id=3052f577&scoped=true"
import script from "./SvgIconBrowser.vue?vue&type=script&lang=js"
export * from "./SvgIconBrowser.vue?vue&type=script&lang=js"
import style0 from "./SvgIconBrowser.vue?vue&type=style&index=0&id=3052f577&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052f577",
  null
  
)

export default component.exports